<template>
  <div
    data-component="agent-status-settings-item"
    :class="{ 'is-active': isActive }"
    @click="$emit('click')"
  >
    <div class="icon-wrapper">
      <or-icon :icon="icon" />
    </div>

    <span
      data-label="status-name"
      class="label"
    >
      {{ label }}
    </span>

    <div
      data-button="drag-start"
      :class="{ 'is-disabled': isDisabled }"
      @click.stop
    >
      <or-icon icon="drag_indicator" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { OrIconV3 as OrIcon } from '@onereach/ui-components-25';

import { AgentStatus } from '@/types';
import { AGENT_STATUS_LABEL, DEFAULT_STATUS_ICONS } from '@/constants';

export default defineComponent({
  name: 'AgentStatusSettingsItem',
  components: { OrIcon },
  props: {
    item: {
      type: Object as PropType<AgentStatus>,
      default: undefined,
    },
    isActive: Boolean,
    isDisabled: Boolean,
  },
  emits: ['click'],
  computed: {
    label() {
      return this.item.label || this.$t(AGENT_STATUS_LABEL[this.item.status]);
    },
    icon() {
      return this.item.icon || DEFAULT_STATUS_ICONS[this.item.status];
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='agent-status-settings-item'] {
  --agent-status-item-bg: var(--or-c-surface);
  --agent-status-item-icon-bg: var(--or-c-primary-opacity-0-08);

  display: flex;
  align-items: center;
  width: 22.5rem;
  padding: 0.5rem;
  border-radius: var(--s-2);
  background: var(--agent-status-item-bg);
  cursor: pointer;

  &:hover,
  &:active {
    box-shadow: var(--or-shadow);
  }

  &.is-active {
    --agent-status-item-bg: var(--or-c-primary-opacity-0-08);
    --agent-status-item-icon-bg: var(--or-c-surface-1);
  }

  .icon-wrapper {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    height: 2.25rem;
    width: 2.25rem;
    border-radius: var(--s-2);
    background: var(--agent-status-item-icon-bg);
  }

  .or-icon-v3 {
    color: var(--or-c-outline);
  }

  .label {
    @include text-overflow;
    flex: 1 1 auto;
    margin: 0 var(--s-4) 0 var(--s-3);
    color: var(--or-c-on-background);
  }

  [data-button='drag-start'] {
    display: flex;
    padding: var(--s-3);
    margin-left: auto;
    user-select: none;
    cursor: grab;

    &.is-disabled {
      pointer-events: none;
      opacity: 0.65;
    }

    &:hover {
      .or-icon-v3 {
        color: var(--or-c-on-background);
      }
    }
  }
}
</style>
